import { render, staticRenderFns } from "./ChipDataTableItem.vue?vue&type=template&id=4b444858"
import script from "./ChipDataTableItem.vue?vue&type=script&lang=js"
export * from "./ChipDataTableItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports